module.exports = __webpack_public_path__ + "img/banner6.fd7e688d.png";